import styles from './RoleChip.module.css';

// plan §5 enum: level은 'editor' | 'viewer'.
// 'admin'은 platform_role이지만 같은 chip 디자인을 공용으로 사용하므로 union으로 묶음.
export type Role = 'admin' | 'editor' | 'viewer';

export type ChipSize = 'sm' | 'md';

interface RoleChipProps {
  role: Role;
  size?: ChipSize;
}

const LABEL: Record<Role, string> = {
  admin: 'Admin',
  editor: 'Editor',
  viewer: 'Viewer',
};

const ROLE_CLASS: Record<Role, string> = {
  admin: styles.roleAdmin,
  editor: styles.roleEditor,
  viewer: styles.roleViewer,
};

const DOT_CLASS: Record<Role, string> = {
  admin: styles.dotAdmin,
  editor: styles.dotEditor,
  viewer: styles.dotViewer,
};

export function RoleChip({ role, size = 'md' }: RoleChipProps) {
  const sizeClass = size === 'sm' ? styles.sizeSm : styles.sizeMd;
  return (
    <span className={[styles.chip, sizeClass, ROLE_CLASS[role]].join(' ')}>
      <span className={[styles.dot, DOT_CLASS[role]].join(' ')} />
      {LABEL[role]}
    </span>
  );
}
